import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class RopaFormValidators {
  /**
   * Validator for array fields that must have at least one selection
   */
  static arrayMinLength(minLength: number = 1): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!Array.isArray(value) || value.length < minLength) {
        return {
          arrayMinLength: {
            requiredLength: minLength,
            actualLength: value?.length || 0,
          },
        };
      }
      return null;
    };
  }

  /**
   * Validator for array fields with maximum selections
   */
  static arrayMaxLength(maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (Array.isArray(value) && value.length > maxLength) {
        return { arrayMaxLength: { maxLength, actualLength: value.length } };
      }
      return null;
    };
  }

  /**
   * Validator for file upload fields
   */
  static fileRequired(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const files = control.value as File[];
      if (!files || !Array.isArray(files) || files.length === 0) {
        return { fileRequired: true };
      }
      return null;
    };
  }

  /**
   * Validator for non-empty string fields
   */
  static nonEmptyString(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (typeof value === 'string' && value.trim().length === 0) {
        return { nonEmptyString: true };
      }
      return null;
    };
  }
}
